import React, { ReactNode, useEffect } from 'react'

import { THEMES } from '../constants'

const initialState = {
    theme: THEMES.DEFAULT,
    setTheme: (t: string) => {
        console.log('setTheme, context not initiatied', t)
    },
}

const ThemeContext = React.createContext(initialState)

function ThemeProvider({ children }: { children: ReactNode }) {
    const [theme, _setTheme] = React.useState(initialState.theme)

    useEffect(() => {
        const storedTheme = localStorage.getItem('theme')

        if (storedTheme) {
            try {
                _setTheme(JSON.parse(storedTheme))
            } catch (error) {
                console.error('Error parsing theme from localStorage:', error)
            }
        }
    }, [])

    const setTheme = (_theme: string) => {
        localStorage.setItem('theme', JSON.stringify(_theme))
        _setTheme(_theme)
    }

    return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>
}

export { ThemeProvider, ThemeContext }
